import React from "react";
import { Box, Typography } from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

/**
 * The "Project" nav item's destination - deliberately empty. The sidebar
 * (AppSidebar) is already mounted alongside this page with the Plant -> WBS
 * -> Documents tree in it; picking a plant/WBS/document there navigates away
 * to whatever shows that data (see ProjectsTreeSection's onSelect). This
 * page is only ever the blank starting point before that pick happens - see
 * navItems.js and mainRoutes.js's `paths.myProjects` entry.
 *
 * Replaces the old PlantsTable grid as the "Project" landing page - that
 * component (src/pages/client/Project/plant/index.jsx) is left in place,
 * just no longer routed here, in case it's needed again.
 */
export default function ProjectLanding() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: "60vh",
        gap: 1.5,
        color: "text.secondary",
        textAlign: "center",
        px: 3,
      }}
    >
      <AccountTreeIcon sx={{ fontSize: 48, color: "text.disabled" }} />
      <Typography variant="h6" color="text.secondary">
        No project selected
      </Typography>
      <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 360 }}>
        Pick a plant, WBS, or document from the tree on the left to see it
        here.
      </Typography>
    </Box>
  );
}
